// src/redux/registerFormReducer.ts
import internal from 'stream'
import { getBaseUrl } from '../../Utils'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Links } from '../../Types/appSettings'

interface SignInInfo {
    EmailAddress: string
    Password: String
}
interface PIVSignInInfo {
    email: string
    name: String
    token: String
    id: number
    issuerName: string
    Links: Links
    Warning: string
    MessageResults?: null[] | null
}
export interface GenericResponse {
    statusCode: number
    MessageResults: any
    data: any
}

interface BrowserInfo {
    browserName: string
    OSName: string
    userAgent: string
    userId: string
    isMobile: boolean
    screenResolution: string
    engine: string
    browserVersion: string
    browserMajorVersion: string
    osVersion: string
    fingerprint: number
}

export const signinFormAPI = createApi({
    reducerPath: 'signin', //our reducer lives at store.reducer
    baseQuery: fetchBaseQuery({ baseUrl: getBaseUrl() + 'API/v3' }), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        performSignIn: build.mutation<GenericResponse, Partial<SignInInfo>>({
            query: (body) => ({
                url: '/Account/SignIn',
                method: 'POST',
                body: body,
            }),
        }),
        performPIVSignIn: build.mutation<GenericResponse, Partial<PIVSignInInfo>>({
            query: (body) => ({
                url: '/Account/PIVAuthorization',
                method: 'POST',
                body: body,
            }),
        }),
        setBrowserDetails: build.mutation<GenericResponse, Partial<BrowserInfo>>({
            query: (body) => ({
                url: '/Account/BrowserDetails/',
                method: 'POST',
                body: body,
            }),
        }),
    }),
})

export const { usePerformSignInMutation, usePerformPIVSignInMutation, useSetBrowserDetailsMutation } = signinFormAPI
// export const registerFormSlice;
